import React from 'react';
import { makeStyles } from '@material-ui/core';
import { IconButton, palette } from '@dev/ee-components';

type TemplatePreviewButtonType = {
    buttonIcon: JSX.Element;
    buttonLabel?: string;
    handleOnClick(): void;
    id?: string;
};

const useStyles = makeStyles({
    root: {
        height: '100%',
    },
    iconButton: {
        margin: '0 2px',
        width: '74px !important',
        height: '74px !important',
        borderRadius: '20px',
    },
    buttonIconContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: palette.indigo[6],
        textTransform: 'none',

        '& svg': {
            fill: palette.indigo[6],
        },
    },
});

export const TemplatePreviewButton = (props: TemplatePreviewButtonType): JSX.Element => {
    const { buttonIcon, buttonLabel, handleOnClick, id } = props;
    const classes = useStyles();

    return (
        <IconButton
            id={id}
            className={classes.iconButton}
            secondary
            icon={
                <div className={classes.buttonIconContainer}>
                    {buttonIcon}
                    {buttonLabel}
                </div>
            }
            onClick={handleOnClick}
        />
    );
};
